import React, { Component } from "react";
import { AutoCompleteItem } from "../../../../Components/Items";
import { cargarSugerencias } from "../cmmsComun";

// Texto libre con sugerencias de lo ya capturado en otros activos (modelo, ubicacion,
// area). Se puede escribir algo nuevo, pero al ver "Qx 1 (12)" el usuario elige el
// existente en vez de inventar "QX1": los datos no se ensucian sin necesidad de un
// catalogo aparte. Compatible con FormItem (value / onChange).
//
// props.params: filtros de la sugerencia, ej. { campo: "area", clienteId, ubicacion }.
class CampoSugerenciasCMMS extends Component {
    state = { opciones: [] };
    temporizador = null;
    clave = "";

    componentWillUnmount() {
        clearTimeout(this.temporizador);
    }

    consultar = (texto) => {
        clearTimeout(this.temporizador);
        this.temporizador = setTimeout(async () => {
            const params = { ...(this.props.params || {}), texto: texto || "" };
            const clave = JSON.stringify(params);
            this.clave = clave;
            const sugerencias = await cargarSugerencias(this.props, params);
            if (this.clave !== clave) return; // llego una respuesta vieja
            this.setState({
                opciones: sugerencias.map((s) => ({
                    value: s.valor,
                    label: (
                        <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                            <span>{s.valor}</span>
                            <span style={{ color: "#8c8c8c", fontSize: 11 }}>
                                {s.total} {s.total === 1 ? "equipo" : "equipos"}
                            </span>
                        </div>
                    ),
                })),
            });
        }, 250);
    };

    render() {
        const { value, onChange, placeholder, disabled } = this.props;
        return (
            <AutoCompleteItem
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                options={this.state.opciones}
                onFocus={() => this.consultar(value)}
                onSearch={this.consultar}
                allowClear
            />
        );
    }
}

export default CampoSugerenciasCMMS;
